var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    { ref: "configurationForm", attrs: { name: "configurationForm" } },
    [
      _c("e-sidebar", {
        attrs: {
          id: "sidebar-price-suggestion-configuration",
          title: _vm.title,
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: { save: _vm.saveConfiguration, hidden: _vm.hideSidebar },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("e-store-combo", {
                          attrs: {
                            id: "price-suggestion-configuration-store",
                            required: false,
                            "select-single-option": false,
                            placeholder: _vm.$t("Geral"),
                            instruction: _vm.$t(
                              "Deixe em branco para uma configuração geral"
                            ),
                          },
                          model: {
                            value: _vm.configurationForm.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.configurationForm, "storeId", $$v)
                            },
                            expression: "configurationForm.storeId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("e-search-sku", {
                          attrs: {
                            id: "price-suggestion-configuration-sku",
                            label: _vm.$t("Produto"),
                            required: false,
                            "only-active": true,
                            "include-fixed-assets": true,
                            placeholder: _vm.$t("Geral"),
                            instruction: _vm.$t(
                              "Deixe em branco para um Geral de produto (todos os produtos)"
                            ),
                            "default-options": _vm.skuDefaultOptions,
                          },
                          model: {
                            value: _vm.configurationForm.skuId,
                            callback: function ($$v) {
                              _vm.$set(_vm.configurationForm, "skuId", $$v)
                            },
                            expression: "configurationForm.skuId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "price-suggestion-configuration-minimum-margin",
                            type: "number",
                            step: 0.01,
                            label: _vm.$t("Margem Mínima (%)"),
                            validation:
                              "required|number|min:0|max:999.99|maxTwoDecimals",
                            "validation-rules": {
                              maxTwoDecimals: _vm.maxTwoDecimals,
                            },
                            "validation-messages": {
                              maxTwoDecimals: _vm.$t(
                                "Informe no máximo duas casas decimais"
                              ),
                            },
                          },
                          model: {
                            value: _vm.configurationForm.minimumMarginPercent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.configurationForm,
                                "minimumMarginPercent",
                                _vm._n($$v)
                              )
                            },
                            expression:
                              "configurationForm.minimumMarginPercent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "price-suggestion-configuration-maximum-variation",
                            type: "number",
                            step: 0.01,
                            label: _vm.$t("Variação Máxima (%)"),
                            validation:
                              "required|number|min:0|max:999.99|maxTwoDecimals",
                            "validation-rules": {
                              maxTwoDecimals: _vm.maxTwoDecimals,
                            },
                            "validation-messages": {
                              maxTwoDecimals: _vm.$t(
                                "Informe no máximo duas casas decimais"
                              ),
                            },
                          },
                          model: {
                            value:
                              _vm.configurationForm.maximumVariationPercent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.configurationForm,
                                "maximumVariationPercent",
                                _vm._n($$v)
                              )
                            },
                            expression:
                              "configurationForm.maximumVariationPercent",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }